export default __webpack_public_path__ + "static/media/CNo.72-2.bbee0e42.jpg";